// extracted by mini-css-extract-plugin
export var aircallIframe = "_mv-3";
export var fabContainer = "_mv-5";
export var fabRinging = "_mv-6";
export var loadingOverlay = "_mv-4";
export var pulse = "_mv-7";
export var widgetContent = "_mv-2";
export var widgetPanel = "_mv-0";
export var widgetPanelExpanded = "_mv-1";